// extracted by mini-css-extract-plugin
module.exports = {"top":"a10a3f92e9--top--CBGuR"};